import { AxiosInstance, AxiosResponse } from "axios";
import { CustomLinkModel, CustomLinkListParams, CustomLinkAddParams } from "./custom-link-types";
import { ApiResponse } from "../public-types";
import ApiPath from "src/api/apiPath.json";
import qs from "qs";

/* 
  RPEL01. 파트너 외부 링크 연결 목록 페이지 조회
*/
export async function getCustomLinkListAsync(
  axios: AxiosInstance,
  params?: CustomLinkListParams,
): Promise<AxiosResponse<ApiResponse<{ content: Array<CustomLinkModel> }>>> {
  return await axios.get<ApiResponse<any>>(ApiPath.customLink.list, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params, { allowDots: true, encode: true }),
    },
  });
}
/* 
  RPEL0?. 파트너 외부 링크 연결 삭제
*/

export async function deleteCustomLinkAsync(
  axios: AxiosInstance,
  params?: {
    id: string;
  },
): Promise<AxiosResponse<ApiResponse<{ id: string }>>> {
  return axios.delete(ApiPath.customLink.delete.replace("{id}", String(params?.id)));
}
/*
  RPEL02. 파트너 외부 링크 연결 생성 처리
*/
export async function postCustomLinkAsync(
  axios: AxiosInstance,
  params?: CustomLinkAddParams,
): Promise<AxiosResponse<ApiResponse<{ customLink: CustomLinkModel }>>> {
  return await axios.post(ApiPath.customLink.add, params);
}
/*
  RPEL03. 파트너 외부 링크 연결 수정 처리
*/
export async function patchCustomLinkAsync(
  axios: AxiosInstance,
  params?: CustomLinkModel,
): Promise<AxiosResponse<ApiResponse<{ customLink: CustomLinkModel }>>> {
  return await axios.patch(ApiPath.customLink.edit.replace("{id}", String(params?.id!)), params);
}
